<template>
  <div class="online-serve">
    <Collapse v-model="activeName" accordion @change='changeHandle'>
      <CollapseItem :title="item.name" :name="item.id" v-for="item in packageList" :key="item.id">
        <Field name="packageRadio">
          <template #input>
            <div style="width:100%">
              <RadioGroup v-model="packageRadio">
                <CellGroup :border="false">
                  <Cell v-for="packageItem in item.service_packages" :key="packageItem.id" :title="packageItem.name" clickable @click="clickHandle(packageItem)">
                    <Radio slot="right-icon" :name="packageItem.id" />
                    <div slot="label">{{packageItem.desc}}</div>
                  </Cell>
                </CellGroup>
              </RadioGroup>
            </div>
          </template>
        </Field>
      </CollapseItem>
    </Collapse>
    <div style="margin: 16px;">
      <Button round block type="info" @click="nextHandle" native-type="submit">
        下一步
      </Button>
      </div>
  </div>
</template>

<script>
import { api,http } from 'utils/'
import { Toast } from 'vant';
export default {
  data() {
    return {
      activeName:1,
      packageRadio:'',
      packageList:[]
    }
  },
  created() {
    document.title = '选择服务项目'
    this.queryPackageList()
  },
  methods:{
    async queryPackageList() {
      const res = await http({
        url:api.packageList
      })
      if(res) {
        this.packageList = res
      }
    },
    changeHandle() {
      console.log(this.packageRadio)
    },
    clickHandle(packageItem) {
      this.packageRadio = packageItem.id
      this.serveName = packageItem.name
    },
    nextHandle() {
      if( this.packageRadio === '' ) {
        Toast('请选择套餐')
      }else{
        this.$router.push(`/serve?service_id=${this.packageRadio}&service_name=${this.serveName}`)
      }
    }
  }
}
</script>

<style lang="less">
.online-serve{
  padding: 20px 12px;
  .van-cell__title {
    text-align: left;
  }
  .van-collapse-item__content{
    padding: 0;
  }
}
</style>